import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=45563816"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"
import style0 from "./Quiz.vue?vue&type=style&index=0&id=45563816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../home/michael/.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports